import React from "react";
import PropTypes from "prop-types";
import { Form as FormikForm, FormikContext } from "formik";

const Form = (props) => {
  const { children, className, formik } = props;

  return (
    <FormikContext value={formik}>
      <FormikForm className={className}>{children}</FormikForm>
    </FormikContext>
  );
};
Form.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  formik: PropTypes.any,
};

export default Form;
